import React from "react";
import { Col, Form, Row } from 'react-bootstrap';
import { FeeThin } from "domain/fee";
import TypedSelect from "common/ui/TypedSelect";
import NumberEditor from "common/ui/NumberEditor";
import "./AddFeeModal.scss";
import * as _ from "lodash";
import { localizeOfferContract as localize, localizeCommon} from "features/localization/localizeService";

export interface AddFeeModalProps {
  fees: FeeThin[];
  selectedFees: FeeThin[];
  disabled: boolean;
  onFeesChanged(fees: FeeThin[]): void;
}

const AddFeeModal: React.FC<AddFeeModalProps> = props => {

    function onAddFeeClicked() {
        const remainingFees = props.fees?.find(f => !props.selectedFees?.some(sf => sf.id === f.id));
        const updatedFees = props.selectedFees != null ? [...props.selectedFees, remainingFees] : [remainingFees];
        props.onFeesChanged(updatedFees);
    }

    function onRemoveFeeClicked(fee: FeeThin) {
        const updatedFees = props.selectedFees?.filter(f => f.id !== fee.id)
        props.onFeesChanged(updatedFees);
    }

    function onFeesChanged(fee: FeeThin) {
        const updatedFees = props.selectedFees?.map(f => f.id === fee.id  ? fee : f)
        props.onFeesChanged(updatedFees);
    }

    function onFeeTypeChanged(fee: FeeThin, oldFee: FeeThin) {
        const updatedFees = props.selectedFees?.map(f => f.id === oldFee.id ? fee : f);
        props.onFeesChanged(updatedFees);
    }

    return <div className="add-fee-modal">{props.selectedFees?.map((fee, idx) => <Form.Group key={idx} as={Row}>
        <Col xs="4">
        <TypedSelect
            className="fee-select"
            disabled={props.disabled}
            nullRowText={localizeCommon("Value_Select")}
            required
            value={{id: fee.id}}
            options={props.fees.filter(f => f.id === fee.id || !props.selectedFees?.some(sf => sf.id === f.id))}
            valueGetter={f => f.id}
            textGetter={f => f.name}
            onValueSelected={f => onFeeTypeChanged(f, fee)} />
        </Col>
        <Col xs="4">
            <NumberEditor className='form-control'
                step={.01}
                allowDecimals
                precision={4}
                disabled={props.disabled}
                enforcePrecision
                value={fee.value}
                placeholder={"0.0000"}
                onValueChange={value => onFeesChanged({ ...fee, value: value })}
            />
        </Col>
        <Col xs="4">
            {!props.disabled && <button type="button" className='link-button mr-auto' onClick={() => onRemoveFeeClicked(fee)}>
                <span className="fa fa-trash remove-fee"></span>
            </button>}
        </Col>
    </Form.Group>)}
    {props.selectedFees?.length !== props.fees?.length && !props.disabled && <Form.Group as={Row}>
        <Col xs="4" className="pr-0">
        <button type="button" className='link-button mr-auto float-right' onClick={onAddFeeClicked}>
            {localize("Details_Button_AddFee")}
        </button>
        </Col>
    </Form.Group>}
    </div>;
}

export default AddFeeModal;